module.exports = "https://r.nearpod.com/assets/media/image/admin_green_icon-0d45689c879d518cd5e358f2c7297f0a.svg";